const tmpl = require("./news-widget.html"),
      BaseWidget = require("../base_widget"),
      NewsModule = require("data/news"),
      c = require("infra/utils/common");

function NewsWidget(newsService, $timeout, $scope, $element, util) {
    this.newsService = newsService;
    this.$timeout = $timeout;
    this.util = util;
    const self = this;
    const TOTAL_STRIDES = 3;
    $scope.stride = 3; // three articles per "page"
    $scope.startIndex = 0;

    $scope.paginate = function (step) {
        const newStartIndex = $scope.startIndex + step;
        if (newStartIndex === TOTAL_STRIDES * $scope.stride || newStartIndex < 0) {
            if (newStartIndex === TOTAL_STRIDES * $scope.stride) {
                $scope.startIndex = 0;
            } else {
                $scope.startIndex = $scope.stride * 2;
            }
        } else {
            $scope.startIndex = newStartIndex;
        }
    };

    $scope.openBrowserTab = (url) => self.$window.open(url);
    $scope.toDate = (dateString) => new Date(dateString);
    $scope.getUrlDomain = function (url) {
        const matches = url.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
        return matches && matches[1];  // will return null if no match is found
    };
}

NewsWidget.prototype._doUpdate = function (values) {
    const selectedTerms = _.filter(values.terms, 'text', this.$scope.brandName);
    const kwd_ids = this.util.getPhrasesToIdMap(selectedTerms);
    const terms = _.map(selectedTerms, 'text');
    if (_.isEmpty(terms)) {
      return Promise.resolve();
    }
    const params = {
      terms,
      results_per_term: 9,
      geos: this.$scope.geos,
      kwd_ids,
      timeframe: c.getTimeframe(30, false),
      brand_name: this.$scope.brandName
    };

    return this.newsService.get(params).then(result => {
            this.$scope.result = result;
            this.$scope.startIndex = 0;
        }
    );
};

NewsWidget.$inject = ["newsService", "$timeout", "$scope", "$element", "util"];
module.exports = angular.module(__filename, [
    NewsModule.name
]).directive("newsWidget", [function () {
    return BaseWidget({
        restrict: "E",
        template: tmpl,
        scope: {
            brandName: "=brandName",
            geos: "=geos",
            terms: "=terms"
        },
        controller: NewsWidget
    });
}]).filter('slice', function () {
    return (arr, start, end) => (arr || []).slice(start, end);
});
